import React, { Fragment } from 'react';
import { SITE_NAME } from 'constants/site';
import { SITE_LOGO } from 'constants/logos';
import LogoLink from '../LogoLink';
import Link from '../Link';

function AmpFooter() {
  const date = new Date();
  const currentYear = date.getFullYear();

  return (
    <Fragment>
      <footer className="AmpFooter">
        <div className="AmpFooter__logo">
          <LogoLink logo={SITE_LOGO} href="/" />
        </div>
        <div className="AmpFooter__submission">
          <p>Got a tip, kitchen tour, or other story our readers should see?</p>
          <Link as="/about/submissions" href="/page?path=/about/submissions">
            <a className="AmpFooter__submission-button">Tell us about it!</a>
          </Link>
        </div>
        <div className="AmpFooter__nav" id="amp-footer-nav" />
        <p className="AmpFooter__legal">
          {`${SITE_NAME} is © 1994-${currentYear}`} Apartment Therapy, LLC
        </p>
      </footer>
      <style jsx>{`
        .AmpFooter {
          border-top: 1px solid #ddd;
          padding: 3rem 0.5rem;
        }

        .AmpFooter__legal,
        .AmpFooter__submission {
          font-family: sans-serif;
          font-size: 12px;
          text-align: center;
        }

        .AmpFooter__logo {
          margin: 0 auto;
          width: 120px;
        }

        .AmpFooter__nav {
          margin-bottom: 1rem;
        }

        .AmpFooter__nav :global(li) {
          grid-column: 2 / 3;
          font-family: sans-serif;
          font-size: 14px;
          text-align: center;
        }

        .AmpFooter__nav :global(ul) {
          display: grid;
          grid-template-columns: 1fr auto 1fr;
        }

        .AmpFooter__nav :global(.nav__heading) {
          margin: 1rem 0 0.5rem;
          border-bottom: 1px solid #000;
          font-weight: bold;
          letter-spacing: 0.05em;
          text-transform: uppercase;
        }

        .AmpFooter__nav :global(.nav__item) {
          margin: 0.25rem 0;
        }

        .AmpFooter__nav :global(.nav__link) {
          color: #000;
          text-decoration: none;
        }

        .AmpFooter__submission {
          margin-bottom: 1rem;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
        }

        .AmpFooter__submission p {
          flex: 0 0 100%;
        }

        .AmpFooter__submission-button {
          display: block;
          border: 1px solid #000;
          padding: 0.5rem;
          color: #000;
          font-family: sans-serif;
          font-size: 12px;
          letter-spacing: 0.05em;
          text-decoration: none;
          text-transform: uppercase;
        }
      `}</style>
    </Fragment>
  );
}

export default AmpFooter;
